import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import Institutions from '../components/institutions/list'
import CreateInstitution from '../components/institutions/create'
import ShowInstitution from '../components/institutions/show'
import EditInstitution from '../components/institutions/show/edit'
import InstitutionContacts from '../components/institutions/show/contacts'
import InstitutionAnalytics from '../components/institutions/show/analytics'
import InstitutionWhitelabel from '../components/institutions/show/whitelabel'
import InstitutionSubAccounts from '../components/institutions/show/sub-accounts'
import InstitutionAccountHolders from '../components/institutions/show/account-holders'

import InstitutionAnswers from '../components/institution-answers/'

import InstitutionUsers from '../components/institution-users/list'
import CreateInstitutionUser from '../components/institution-users/create'
import EditInstitutionUser from '../components/institution-users/edit'

import InstitutionNotes from '../components/institution-notes/list'
import CreateInstitutionNote from '../components/institution-notes/create'
import EditInstitutionNote from '../components/institution-notes/edit'

import InstitutionSchools from '../components/institution-schools/list'
import CreateInstitutionSchool from '../components/institution-schools/create'
import EditInstitutionSchool from '../components/institution-schools/edit'
import InstitutionSchoolsImportPage from '../components/InstitutionSchoolsImportPage'

import MembershipPlans from '../components/membership-plans/list'
import CreateMembershipPlan from '../components/membership-plans/create'
import EditMembershipPlan from '../components/membership-plans/edit'

import InstitutionMemberships from '../components/institution-memberships/list'
import CreateInstitutionMembership from '../components/institution-memberships/create'
import EditInstitutionMembership from '../components/institution-memberships/edit'

import UserMemberships from '../components/user-memberships/list'
import CreateUserMembership from '../components/user-memberships/create'
import EditUserMembership from '../components/user-memberships/edit'

const MembershipRoutes = (
  <Route path='membership'>
    <Route path='institutions'>
      <IndexRoute component={Institutions} />
      <Route path='create' component={CreateInstitution} />
      <Route path='import-schools' component={InstitutionSchoolsImportPage} />
      <Route path=':institutionId' component={ShowInstitution}>
        <IndexRedirect to='edit' />
        <Route path='edit' component={EditInstitution} />
        <Route path='sub-accounts' component={InstitutionSubAccounts} />
        <Route path='account-holders' component={InstitutionAccountHolders} />
        <Route path='survey' component={InstitutionAnswers} />
        <Route path='contacts' component={InstitutionContacts} />
        <Route path='notes'>
          <IndexRoute component={InstitutionNotes} />
          <Route path='create' component={CreateInstitutionNote} />
          <Route path=':institutionNoteId/edit' component={EditInstitutionNote} />
        </Route>
        <Route path='schools'>
          <IndexRoute component={InstitutionSchools} />
          <Route path='create' component={CreateInstitutionSchool} />
          <Route path=':institutionSchoolId/edit' component={EditInstitutionSchool} />
        </Route>
        <Route path='analytics' component={InstitutionAnalytics} />
        <Route path='whitelabel' component={InstitutionWhitelabel} />
      </Route>
    </Route>

    <Route path='institution-users'>
      <IndexRoute component={InstitutionUsers} />
      <Route path='create' component={CreateInstitutionUser} />
      <Route path=':institutionUserId/edit' component={EditInstitutionUser} />
    </Route>

    <Route path='membership-plans'>
      <IndexRoute component={MembershipPlans} />
      <Route path='create' component={CreateMembershipPlan} />
      <Route path=':membershipPlanId/edit' component={EditMembershipPlan} />
    </Route>

    <Route path='institution-memberships'>
      <IndexRoute component={InstitutionMemberships} />
      <Route path='create' component={CreateInstitutionMembership} />
      <Route path=':membershipId/edit' component={EditInstitutionMembership} />
    </Route>

    <Route path='user-memberships'>
      <IndexRoute component={UserMemberships} />
      <Route path='create' component={CreateUserMembership} />
      <Route path=':membershipId/edit' component={EditUserMembership} />
    </Route>
  </Route>
)

export default MembershipRoutes
